/**
 * Created by weid on 2017/9/8.
 */
/**
 * Redux types 命名冲突解决方案
 *
 * Example:
 *   import typesGenerator from 'typesGenerator';
 *   export default typesGenerator('agency_signin', `
 *     SET_USER_INFO
 *     OTHER_TYPE
 *   `)
 *
 *   result:
 *     {
 *       SET_USER_INFO: 'agency_signin@SET_USER_INFO',
 *       OTHER_TYPE: 'agency_signin@OTHER_TYPE',
 *     }
 */
const namespaceStore = [];

export default function typesGenerator(namespace, types) {
    if (!types) {
        return console.error('namespace are required.');
    }

    if (namespaceStore.indexOf(namespace) !== -1) {
        return console.error(`${namespace} namespace has been occupied.`);
    }
    namespaceStore.push(namespace);

    const exposed = {};

    types
        .trim()
        .replace(/[\s\b]+/g, '\n')
        .split('\n')
        .forEach((type) => {
            exposed[type] = `${namespace}@${type}`;
        });

    return exposed;
}



// WEBPACK FOOTER //
// ./src/rootRedux/extensions/typesGenerator.js